module.exports = __webpack_public_path__ + "img/research_youkeyuan.d3bb6275.png";